import { NotImplementedError } from "../../Errors";
import { iterateValues } from "../../IterableUtils";
import { delay } from "../../AsyncUtils";
import {
    INidusClient,
    NidusEntry,
    NidusEntryData,
    NidusEntryId,
    NidusName,
    NidusReferenceKey,
    NidusSearchResponse,
} from "../INidusClient";

import { createUniqueNidusEntryId } from "./CreateUniqueNidusEntryId";

export class FakeNidusClient implements INidusClient {
    private nidusEntries: NidusEntry[] = [];

    public constructor(initialData: NidusEntryData[]) {
        this.nidusEntries = initialData.map(x => ({ id: createUniqueNidusEntryId(), data: x }));
    }

    public async batchInsert(): Promise<void> {
        await this.fakeDelay();
        throw new NotImplementedError();
    }

    public async delete(_: NidusName, __: NidusReferenceKey, objectId: NidusEntryId): Promise<void> {
        await this.fakeDelay();
        this.nidusEntries = this.nidusEntries.filter(x => x.id !== objectId);
    }

    public async insert(_: NidusName, __: NidusReferenceKey, obj: NidusEntryData): Promise<NidusEntry> {
        await this.fakeDelay();
        const result = { id: createUniqueNidusEntryId(), data: obj };
        this.nidusEntries.push(result);
        return result;
    }

    public async search(
        _: NidusName,
        __: NidusReferenceKey,
        searchValue: string | null | undefined
    ): Promise<NidusSearchResponse> {
        await this.fakeDelay();
        const nidusEntries = this.nidusEntries;
        if (searchValue == "" || searchValue == undefined) {
            return {
                items: nidusEntries,
                totalSuitableCount: nidusEntries.length,
            };
        }
        const items = nidusEntries.filter(x => {
            for (const value of iterateValues(x.data)) {
                if (value.toLowerCase().includes(searchValue ?? "")) {
                    return true;
                }
            }
            return false;
        });
        return {
            items: items,
            totalSuitableCount: items.length,
        };
    }

    public searchMinitour(
        nidusName: string,
        key: NidusReferenceKey,
        searchValue: string | null | undefined
    ): Promise<NidusSearchResponse> {
        return this.search(nidusName, key, searchValue);
    }

    public update(): Promise<void> {
        return Promise.resolve(undefined);
    }

    private async fakeDelay(): Promise<void> {
        await delay(100);
    }
}
